import React, { useEffect, useState } from "react";

// State
import { connect } from "react-redux";

// UI Components
import { Modal, Form, Button, Row, Col } from "react-bootstrap";

import { ssoUser, loginWithPassword } from "../../state/actions/user";

import { Tenant } from "../../types/tenant";

function ModalTenants({
  showModal,
  toggleModal,
  user,
  tenants,
  ssoUser,
  email,
  password,
  loginWithPassword,
}: any) {
  const [show, setShow] = useState(showModal || false);
  const [tenantIndex, setTenantIndex] = useState(0);

  const { ssoPayload } = user;

  useEffect(() => {
    // Handle manually
    if (typeof showModal === "boolean") {
      setTenantIndex(0);
      setShow(showModal);
    }

    // Handle automatically
    else if (tenants.list.length > 0) {
      setTenantIndex(0);
      setShow(true);
    }
  }, [showModal, tenants]);

  // Show/Hide Modal
  const toggleShow = () => {
    setShow(!show);

    if (toggleModal) {
      toggleModal(!show);
    }
  };

  const handleCancel = () => {
    if (toggleModal) {
      toggleShow();
    } else {
      localStorage.clear();
      sessionStorage.clear();
      window.location.reload();
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault(); // Prevent page from submitting

    if (user.isSsoAuthenticated) {
      // TODO: redirect to SSO or email/pass signin
      ssoUser(ssoPayload.vendor, ssoPayload.authData, tenants.list[tenantIndex].list[0].email);
    } else {
      loginWithPassword({ email, password, tenant: tenants.list[tenantIndex].list[0].email });
    }

    if (toggleModal) {
      toggleShow();
    }
  };

  const onTenantChange = (e: any) => {
    setTenantIndex(e.target.value);
  };

  return (
    <Modal
      size="sm"
      show={show}
      onHide={toggleShow}
      animation={false}
      backdrop="static" // Disallow user from clicking outside to close
      keyboard={false} // Disallow user from pressing escape to close
    >
      <Form noValidate onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>Choose Tenant</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row className="g-2">
            <Col md>
              <Form.Label>
                This option is only accessible to Convey internal users.
                {<br />}
                {<br />}
                Please choose a tenant to log into:
              </Form.Label>

              <Form.Control as="select" id="tenant" onChange={onTenantChange}>
                {tenants.list.map((element: Tenant, index: number) => (
                  <option value={index} key={index}>
                    {element.tenant}
                  </option>
                ))}
              </Form.Control>
            </Col>
          </Row>
          {/*
            <Row className="g-2 mt-2">
              <Col md>
                <Form.Label>Client</Form.Label>
                <Form.Control
                  as="select"
                  id="domain"
                >
                  {
                    tenants.list[tenantIndex] ? tenants.list[tenantIndex].list.map((client: ClientInfo, index: number) => <option value={client.email} key={index}>{client.name}</option>)
                      : null
                  }
                </Form.Control>
              </Col>
            </Row>
          */}
        </Modal.Body>

        <Modal.Footer className="justify-content-between">
          <Button variant="outline-danger" size="sm" onClick={handleCancel}>
            Cancel
          </Button>

          <Button variant="success" size="sm" type="submit">
            Sign In
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

const mapStateToProps = (state: any, ownProps: any) => ({
  // From Redux
  user: state.user,
  tenants: state.tenants,

  // Passed in as attributes
  email: ownProps.email,
  password: ownProps.password,
  showModal: ownProps.show,
  toggleModal: ownProps.toggleModal,
});

export default connect(mapStateToProps, { ssoUser, loginWithPassword })(ModalTenants);
